import logo from './logo.svg';
import './App.css';
import CRMForm from './components/InputForm/InputForm';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import BigFiveCRMTemplates from './components/HomePage/HomePage';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<BigFiveCRMTemplates />} />
      <Route path="/:name" element={<CRMForm/>} />
    </Routes>
    </BrowserRouter>
  );
}

export default App;
